import React from 'react';
import cn from 'classnames';
import { useTranslation } from '@lt/localization';

import type Props from './types';
import styles from './sidebarMenuPayment.module.css';

const SidebarMenuPayment = ({ className = '' }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <div className={styles.text}>
        {t('checkout.sidebar.paymentByCard')}{' '}
        {t('checkout.sidebar.installmentPayment')}
      </div>
      <p className={cn(styles.text, styles.noteText)}>
        {t('checkout.sidebar.note')}
      </p>
    </div>
  );
};

export default SidebarMenuPayment;
